$('.nav-mobile').click(function() {
  $(this).find('i').toggleClass('fa-bars fa-times')
  if($('.navbar-mobile').is(':visible')) {
    $('.navbar-mobile').hide()
  } else {
    $('.navbar-mobile').show()
  }
})
